// modifies uibModalWindow, to make it also add aria attributes automagically
function uibModalWindow($timeout) {
	return {
		link: function(scope, element) {
			$timeout(function() {
				const modal = element[0];
				setDefaultAttr(modal, "aria-modal", "true");
				setDefaultAttr(modal, "aria-labelledby", getHeaderId(modal));
			});
		}
	};

	// this wraps the setAttribute function to avoid overriding manually pre-existing attributes
	function setDefaultAttr(element, attributeName, value) {
		if(!element.getAttribute(attributeName)) {
			element.setAttribute(attributeName, value);
		}
	}

	function getHeaderId(element) {
		// searches for first valid header tag so as to not assume that future tags will be h4
		const validHeaderTags = "h1, h2, h3, h4, h5, h6";
		const id = element.querySelector(validHeaderTags).id;
		return id;
	}
}
export default angular
	.module("vesl.behaviors.uib-modal-window", [])
	.directive("uibModalWindow", uibModalWindow).name;
